import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { OrganizationThirdPartyApiService } from '@_services/api/organization-third-party-api.service';
import { AppState } from '@_store/index.reducers';
import { GeneratedOrganizationThirdPartyEffects } from './organization-third-party-generated.effects';

@Injectable()
export class OrganizationThirdPartyEffects extends GeneratedOrganizationThirdPartyEffects {
  constructor(
    actions$: Actions,
    organizationThirdPartyApiService: OrganizationThirdPartyApiService,
    store$: Store<AppState>
  ) {
    super(actions$, organizationThirdPartyApiService, store$);
  }
}
